import { Paper, Text } from "@mantine/core"

interface DetailSectionProps {
  title: string
  children: React.ReactNode
}

export default function DetailSection({ title, children }: DetailSectionProps) {
  return (
    <Paper withBorder p="md">
      <Text size="xs" tt="uppercase" fw={600} c="dimmed" lts="0.05em" mb="sm">
        {title}
      </Text>
      {children}
    </Paper>
  )
}
